module.exports = __webpack_public_path__ + "static/liva-convert-detail4-dd7555463ae5ce5cce924a2ae105a368.png";